import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiKeysService } from '../services';

/**
 * Hook para ativar uma API Key
 *
 * @example
 * const { mutate: activateKey, isPending } = useActivateApiKey();
 *
 * const handleActivate = () => {
 *   activateKey(keyId);
 * };
 */
export const useActivateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => ApiKeysService.activateApiKey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
};
